<template>
  <div class="auth" v-if="Object.keys(accountInfo).length > 0">
    <Row v-if="accountInfo.passCode === 404">
      <Col span="24">
        <div class="box">
          <span>联盟ID：{{accountInfo.uname}}</span>
          <div>
            <span class="ash">未实名认证（暂不能推广得收益）</span>
            <router-link to="/realname">去实名认证</router-link>
          </div>
        </div>
      </Col>
      <Col span="12">
        <span>真实姓名：{{accountInfo.contact}}</span>
        <span class="mgl10 ash">未认证</span>
      </Col>
      <Col span="12">
        <span>手机：{{accountInfo.mobile}}</span>
        <span class="mgl10 ash">未认证</span>
        <!-- <span :class="['mgl10', accountInfo.isBindMobile === 1 ? 'red' : 'ash']">{{accountInfo.isBindMobile === 1 ? "已绑定" : "未绑定"}}</span> -->
        <span class="mgl10 red" @click="mobileShow">修改</span>
      </Col>
      <Col span="12">
        <span>推广标识码：{{accountInfo.promotersCode ? accountInfo.promotersCode : "暂无"}}</span>
      </Col>
      <Col span="12">
        <span>登录密码：{{accountInfo.upwd}}</span>
        <span class="mgl10 red" @click="passwordShow">修改</span>
      </Col>
    </Row>
    <Row v-else>
      <Col span="24">
        <div class="box">
          <div>
            <span>联盟ID：{{accountInfo.uname}}</span>
            <span class="mgl10" v-if="accountInfo.passCode === 2">已实名</span>
          </div>
          <span class="ash" v-if="accountInfo.passCode === 2">{{accountInfo.contact}}</span>
          <span class="mgl10 ash" v-if="accountInfo.passCode === 2">认证时间：{{accountInfo.addtime}}</span>
          <span class="mgl10" v-if="accountInfo.passCode === 2">等级：{{accountInfo.proportion}}</span>
          <router-link to="/agreement" class="mgl10" v-if="accountInfo.passCode === 2">用户协议</router-link>
        </div>
      </Col>
      <Col span="12">
        <span>真实姓名：{{accountInfo.contact}}</span>
        <span class="mgl10">身份证：{{accountInfo.cardNo}}</span>
        <span class="mgl10" v-if="accountInfo.passCode === 2">已认证</span>
        <span class="mgl10 red" @click="seeRealInfoShow">查看</span>
      </Col>
      <Col span="12">
        <span>手机：{{accountInfo.mobile}}</span>
        <span class="mgl10" v-if="accountInfo.passCode === 2">已认证</span>
      </Col>
      <Col span="12" v-if="accountInfo.passCode === 2">
        <span>推广标识码：{{accountInfo.promotersCode ? accountInfo.promotersCode : "暂无"}}</span>
      </Col>
      <Col span="12">
        <span>登录密码：{{accountInfo.upwd}}</span>
        <span class="mgl10 red" @click="passwordShow">修改</span>
      </Col>
      <Col span="12">
        <span>银行卡：{{accountInfo.dueBank}}</span>
        <span class="mgl10">{{accountInfo.bankCard}}</span>
        <span class="mgl10 red" @click="seeRealInfoShow">查看</span>
        <span class="mgl10 red" @click="editBankInfoShow">修改</span>
      </Col>
    </Row>
    <password ref="password" />
    <mobile ref="mobile" />
    <seeRealInfo ref="seeRealInfo" :contact="accountInfo.contact" :passCode="accountInfo.passCode" />
    <editBankInfo ref="editBankInfo" :contact="accountInfo.contact" :passCode="accountInfo.passCode" />
  </div>
</template>

<script>
import password from "./cell/password"
import mobile from "./cell/mobile/index"
import seeRealInfo from "./cell/realInfo/cell/see"
import editBankInfo from "./cell/realInfo/cell/edit"
export default {
  name: "Auth",
  components: {
    password,
    mobile,
    seeRealInfo,
    editBankInfo
  },
  computed: {
    accountInfo() {
      return this.$store.getters["account/accountInfo"]
    }
  },
  methods: {
    passwordShow() {
      this.$refs["password"].modal = true
    },
    mobileShow() {
      this.$refs["mobile"].curStep = 0
      this.$refs["mobile"].modal = true
    },
    seeRealInfoShow() {
      this.$refs["seeRealInfo"].modal = true
    },
    editBankInfoShow() {
      this.$refs["editBankInfo"].modal = true
    }
  }
}
</script>

<style lang="scss" scoped>
.auth{
  .ivu-row{
    .ivu-col{
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      .ash{
        color: #999;
      }
      .red, a{
        color: #e13b29;
        cursor: pointer;
      }
      .mgl10{
        margin-left: 12px;
      }
    }
  }
}
</style>